import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "metro_logo",
  "use": "metro_logo-usage",
  "viewBox": "0 0 18 13",
  "content": "<symbol viewBox=\"0 0 18 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"metro_logo\"><path d=\"M11.925 7.787l1.214 3.53h-.98v1.555H18v-1.554h-1.115L12.69 0 9 6.968 5.311 0 1.115 11.318H0v1.554h5.841v-1.554h-.98l1.214-3.53L9 13z\" fill=\"#D9252A\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol